<template lang="html">
  <div>
    <vx-card>
      <div class="title">
        <vs-button icon-pack="feather" type="border" size="10px;" icon="icon-chevrons-left" @click="$router.push('/apps/admin/college-form').catch(() => {})"></vs-button>
        <h1 style="text-align:center">{{collegeInfo.name}}({{collegeInfo.campus_name}})</h1>
      </div>
      <vs-tabs class="tab-action-btn-fill-conatiner">
        <vs-tab label="학교 정보" icon-pack="feather" icon="icon-home">
          <vx-card>
          <div class="form tabs-container px-6 pt-6" style="display:flex; flex-wrap: wrap; justify-content:space-between;">
            <div style="display:flex; width:50%">
              <div style="width:30%">
                <p style="font-size:12px; margin-left:5px; margin-top:5px;">학교 로고</p>
                <div class="school_logo" style="padding:20px; min-width:200px; max-width: 200px; box-shadow: 0px 0px 7px rgb(0 0 0 / 20%);">
                  <img v-if="univImg" :src="'https://211.53.129.38/' + univImg" style="width:100px; margin: 0 auto" alt="">
                </div>
                <vs-input ref="imgPath" type="file"
                          name="image" accept="image/*" multiple="multiple"
                          width="100px" style="max-width: 200px; padding: 0; margin-right:30px; margin-top:10px"
                          v-model="imgPath"
                          @change="handleFileChange"/>
                          <p style="margin:5px 0 0 40px; font-size:10px;">*PNG파일만 업로드 해주세요</p>
              </div>
              <div style="width:70%; padding:0 20px 0 10px;">
                <div style="display:flex; width:100%">
                  <vs-input label="학교명" style="width:40%; margin-right:10px;" v-model="collegeInfo.name" type="text" />
                  <vs-input label="캠퍼스명" style="width:30%; margin-right:10px;" v-model="collegeInfo.campus_name" type="text" />
                  <vs-input label="학교 구분(N 년제)" style="width:30%;" v-model="collegeInfo.school_type" type="text" />
                </div>
                <div>
                    <vs-input label="주소" style="width:100%; margin-top:4px" placeholder="주소를 입력해주세요" type="text" name="" v-model="collegeInfo.address" />
                  <div>
                    <vs-input label="슬로건" style="width:100%; margin-top:4px;" type="text" v-model="collegeInfo.slogan" />
                  </div>
                  <div>
                    <vs-input label="학교 웹사이트(URL)" style="width:100%; margin-top:4px;" v-model="collegeInfo.home_link" type="text" />
                  </div>
                </div>
              </div>
            </div>
              <div style="display:flex; justify-content:space-between; width:50%">
                <div class="quill-wrap" style="width:70%">
                  <span style="font-size:12px;">학교 설명</span>
                  <quill-editor :options="editorOption" v-model="collegeInfo.info"></quill-editor>
                </div>
                <div>
                  <div class="mt-4">
                    <label class="text-sm">N 년제</label>
                    <div class="mt-2">
                      <vs-radio v-model="collegeInfo.school_gubun" vs-name="gradeSystem" :vs-value="'정규4년제'" class="mr-4">정규4년제</vs-radio>
                      <vs-radio v-model="collegeInfo.school_gubun" vs-name="gradeSystem" :vs-value="'2·3년제'" class="mr-4">2·3년제</vs-radio>
                    </div>
                  </div>
                  <div class="mt-4">
                    <label class="text-sm">서비스 여부</label>
                    <vs-switch color="success" v-model="collegeInfo.service">
                      <span slot="on">on</span>
                      <span slot="off">off</span>
                    </vs-switch>
                  </div>
                </div>
              </div>
            </div>
            <div style="display:flex; padding:0 20px">
              <vs-button class="text-sm" color="primary" style="width:2000px; height:40px; margin-top: 25px; margin-left:20px; margin-right:20px;" type="border" icon-pack="feather" size="small" icon="icon-save" @click="saveSchoolInfo()">학교 정보 저장</vs-button>
            </div>
          </vx-card>
          <vx-card style="margin-top:20px; width:100%">
            <div style="width:100%; display:flex; justify-content:space-between">
              <div style="margin-top:30px; width:27%;">
                <span style="font-size:15px;">학과 리스트</span>
                <vx-card style="width:100%; margin-top:10px; padding-right:10px;">
                  <vs-button class="text-sm" @click="popupState = !popupState" color="success" type="border" icon-pack="feather" icon="icon-plus" size="small" style="height:35px; margin-top:3px; width:100%;">학과 추가</vs-button>
                  <div style="max-height:625px; overflow-y:auto; padding:10px; margin-top:10px;">
                    <div v-for="(item , index) in majorList" :key="index" :value="item.name">
                      <div style="display:flex; width:100%; height:55px; box-shadow: 0px 5px 10px 0px rgb(0 0 0 / 10%); border-radius:7px; padding:5px;  margin-bottom:10px;">
                        <div class="hover" :class="{major_bg: department.id == item.id}" @click="appearRight(item , index)" style="font-size:16px; width:250px; height: 35px; margin-left:18px; margin-top:5px; color:#1D9CD3; border-radius: 10px; text-align:center; line-height:34px; cursor: pointer">
                          <strong># {{item.name}}</strong>
                        </div>
                        <div>
                        <vs-button @click="delMajorItem(item , index)" type="border" icon-pack="feather" size="small" icon="icon-trash-2" color="danger" style="margin-top:8px; margin-left:22px;"></vs-button>
                      </div>
                      </div>
                    </div>
                  </div>
                </vx-card>
              </div>

              <div style="width:70%; display:flex; flex-direction:column; margin-top:30px;">
                <span style="font-size:15px;">학과 기본 정보</span>
                <vx-card style="width:100%; margin-top:10px;">
                  <div style="display:flex; justify-content:center; flex-direction:column;">
                    <div>
                      <div style="display:flex; justify-content:space-between; margin-bottom:10px;">
                        <div style="display:flex;">
                          <vs-input disabled label="학과명" style="margin-right:10px;"  type="text" name="" v-model="department.name"/>
                          <div>
                            <vs-input label="# 진로 취업 분야" style="margin-right:10px;" @keyup.backspace="deleteTag()" @keypress.enter="commitTag()" type="text" name="" v-model="tagInput"/>
                            <div style="display:flex">
                              <div v-for="(item , index) in department.job_list" :key="index">
                                <div @click="tagInput = item , activeTagIndex = index , activeTagEdit = true" style="height:20px; padding:3px 5px; margin-right:5px; margin-top:5px; font-size:12px; float:left; border-radius:5px; background:#FFE998; cursor:pointer">
                                  #{{item}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="mt-4" style="margin-left:20px;">
                            <label class="text-sm">학과 운영 여부</label>
                            <vs-switch color="success"
                              v-model="department.state">
                              <span slot="on">on</span>
                              <span slot="off">off</span>
                            </vs-switch>
                          </div>
                        </div>
                        <vs-button class="text-sm" color="primary" type="border" icon-pack="feather" icon="icon-save" size="small" style="height:35px; width:200px margin-top:21px;" @click="saveMajorInfo()">학과 기본 정보 저장</vs-button>
                      </div>
                      <div class="quill-wrap" style="width:100%;">
                        <span style="font-size:12px;">학과 설명</span>
                        <quill-editor :options="editorOption" v-model="department.info"></quill-editor>
                      </div>
                    </div>
                  </div>
                </vx-card>

                <div style="margin-top:25px; display:flex; flex-direction:column">
                  <span style="font-size:15px;">연도별 정시 모집 요강</span>
                  <div style="display:flex; justify-content:space-between">
                    <vs-col vs-w="4" style="width:30%">
                      <vx-card style="width:100%">
                        <div style="display:flex;">
                          <vs-button color="success" type="border" icon-pack="feather" icon="icon-plus" size="small" style="height:30px; width:100%;" @click="popupActive = !popupActive">연도 추가</vs-button>
                        </div>
                        <div v-if="grd && grd.length" style="margin-top:20px;">
                          <div v-for="(item , index) in grd" :key="index">
                            <div style="display:flex; width:100%; height:40px; box-shadow: 0px 5px 10px 0px rgb(0 0 0 / 10%); border-radius:8px; padding:5px;  margin-bottom:10px; cursor:pointer">
                              <div class="yearhover" :class="{grd_bg: grdInfo.id == item.id}" @click="appearInfo(item , index)" style="font-size:15px; width:250px; height: 25px; margin-top:3px; color:gray; blue; border-radius: 7px; text-align:center; line-height:25px; margin-left:10px;">
                                <strong>{{item.year}}</strong>학년도 모집 요강
                              </div>
                              <div>
                              <vs-button @click="deleteYear(item , index)" type="border" icon-pack="feather" size="small" icon="icon-trash-2" color="danger" style="margin-top:1px; margin-left:15px; margin-right:12px;"></vs-button>
                            </div>
                            </div>
                        </div>
                      </div>
                      </vx-card>
                    </vs-col>
                    <vs-col vs-w="8" style="width:67%">
                      <vs-row>
                        <vx-card>
                          <p class="text-sm">모집군</p>
                          <div style="display: flex; justify-content: space-between; margin-top:3px;">
                            <div style="display:flex; margin-bottom:10px;">
                              <vs-radio vs-name="grouping" v-model="grdInfo.type_id" :vs-value="'가군'" style="margin-right:10px">가군</vs-radio>
                              <vs-radio vs-name="grouping" v-model="grdInfo.type_id" :vs-value="'나군'" style="margin-right:10px">나군</vs-radio>
                              <vs-radio vs-name="grouping" v-model="grdInfo.type_id" :vs-value="'다군'">다군</vs-radio>
                            </div>
                            <div style="display:flex">
                              <vs-input label="경쟁률(정원내) : 1" style="margin-right:10px; width:150px;" type="text" name="" v-model="grdInfo.comp_rate" />
                              <vs-input label="모집인원(명)" style="margin-right:10px; width:150px;" type="text" name="" v-model="grdInfo.recruit_val" />
                            </div>
                          </div>
                          <div style="display:flex; justify-content:space-between; margin-top:15px">
                            <div style="width:50%; display:flex">
                              <vs-input label="상위" style="margin-right:5px; width:20%;" type="text" name="" v-model="grdInfo.percent" />
                              <p style="width:20%; margin-top:30px">% cut</p>
                              <vs-input label="환산점수" style="margin-right:10px; width:40%;" type="text" name="" v-model="grdInfo.total" />
                            </div>
                            <!-- <div style="width:40%; display:flex; margin-top:20px;">
                              <vs-radio v-model="grdInfo.val_type_id" vs-name="standard" :vs-value="'표준점수기준'" class="mr-4">표준점수 기준</vs-radio>
                              <vs-radio v-model="grdInfo.val_type_id" vs-name="standard" :vs-value="'등급컷기준'" class= "mr-4">등급컷 기준</vs-radio>
                            </div> -->
                          </div>
                          <div style="display:flex; margin-top:10px;">
                            <div style="display:flex; width:647px;">
                                  <ScoreList :score="grdDetail.subject_score_list" @score="setScore" style="width:100%;" />
                                  <!-- <RateList v-if="grdInfo.val_type_id == '등급컷기준'" :rate="grdInfo.subject_score_list"  @rate="setRate"  style="width:100%;" /> -->
                              </div>
                          </div>
                          <vs-button @click="saveGrdInfo()" class="text-sm" color="primary" type="border" icon-pack="feather" icon="icon-save" size="small" style="width:100%; margin-top:15px;">학과 기본 정보 저장</vs-button>
                        </vx-card>
                      </vs-row>
                    </vs-col>
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </vs-tab>
      </vs-tabs>
    </vx-card>
    <Modal v-if="popupState" :popupState="popupState" @close="popupState = !popupState" />
    <div ref="embed" :style="{display : state}" style="position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); background:white;box-shadow:0px 0px 7px rgb(0 0 0 / 20%); z-index:999; display:none ">
        <div @click="state = 'none'" style="width:20px; height:20px; background:black; cursor:pointer; margin-bottom:15px;">
          <x-icon size="1.5x" class="custom-class" style="color:white"></x-icon>
        </div>
    </div>
    <div>
      <vs-popup title="연도별 모집 요강 생성" :active.sync="popupActive">
        <div>
          <div style="width:100%; background:#FAFBFC; padding-bottom: 20px;">
            <div style="padding-left: 20px; padding-top:15px;">
            <vs-select
              label="연도 선택"
              v-model="selectYear"
              style="margin-right:20px;"
              >
                <vs-select-item
                    v-for="(item , index) in yearList"
                    :key="index"
                    :value="item"
                    :text="item"/>
              </vs-select></div>
              <div style="display:flex; margin-top:25px; margin-left:20px;">
                <vs-radio vs-name="groupType" v-model="groupType" :vs-value="'가군'" style="margin-right:10px">가군</vs-radio>
                <vs-radio vs-name="groupType" v-model="groupType" :vs-value="'나군'" style="margin-right:10px">나군</vs-radio>
                <vs-radio vs-name="groupType" v-model="groupType" :vs-value="'다군'" style="margin-right:10px">다군</vs-radio>
                <vs-radio vs-name="groupType" v-model="groupType" :vs-value="'기타'">기타</vs-radio>
              </div>
              <!-- <div style="display:flex; margin-top:25px; margin-left:20px;">
                <vs-radio v-model="valType" vs-name="valType" :vs-value="'표준점수 기준'" class="mr-4">표준점수 기준</vs-radio>
                <vs-radio v-model="valType" vs-name="valType" :vs-value="'등급컷 기준'" class= "mr-4">등급컷 기준</vs-radio>
              </div> -->
          </div>
          <div style="text-align:center">
              <vs-button color="primary" style="margin-top:10px" @click="addMajorGrdItem()">생성</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {
  quillEditor
} from 'vue-quill-editor'

import Quill from 'quill'
import {
  ImageDrop
} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
import Modal from '@/views/pages/admin-college/Modal.vue'
import ScoreList from '@/views/pages/admin-college/ScoreList.vue'
import RateList from '@/views/pages/admin-college/RateList.vue'
export default {
  name: 'daumMap',
  components: {
    quillEditor,
    ScoreList,
    RateList,
    Modal,
    XIcon
  },
  data() {
    return {
      grd: [],
      displayBasicInfo: false,
      displayYogang: false,
      group: 0,
      stand: 0,
      grouping: 0,
      images: '',
      imgPath: '',
      zipCode: '',
      checkScore:'',
      checkRate:'',
      state: 'none',
      questionType: 0,
      standardVal: [0 , 1],
      typeVal: [0 , 1],
      groupType: null,
      valType: [0 , 1],
      popupState: false,
      popupActive: false,
      department: '',
      collegeInfo: {},
      major: {},
      defaultScore: [

      ],
      activeTag: 0,
      score: [

      ],
      activeTagEdit: false,
      activeIndex: 0,
      grdInfo: {},
      activeGrdIndex: 0,
      activeDepartMent: {},
      yearList : [],
      selectYear: 1,
      totalSum: 0,
      totalRate: 0,
      tag: [],
      tagInput: '',
      activeTagIndex: 0,
      wanted: 0,
      recruitInfo: {},
      count: 0,
      scoreInfo: [],
      editorOption: {
        modules: {
          imageDrop: true,
          imageResize: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{
              'header': 1
            }, {
              'header': 2
            }],
            [{
              'list': 'ordered'
            }, {
              'list': 'bullet'
            }],
            [{
              'script': 'sub'
            }, {
              'script': 'super'
            }],
            [{
              'indent': '-1'
            }, {
              'indent': '+1'
            }],
            [{
              'direction': 'rtl'
            }],
            [{
              'size': ['small', false, 'large', 'huge']
            }],
            [{
              'header': [1, 2, 3, 4, 5, 6, false]
            }],
            [{
              'font': []
            }],
            [{
              'color': []
            }, {
              'background': []
            }],
            [{
              'align': []
            }],
            ['clean'],
            ['link', 'image', 'video']
          ],
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    activeCollege() {
      return this.$store.state.etest.activeCollege
    },
    activeMajor() {
      return this.$store.state.etest.majorList
    },
    majorList() { //원래는 위에꺼로 v-model
      return this.$store.state.etest.majorList
    },
    scoreList() {
      return this.$store.state.etest.scoreList
    },
    grdList() {
      return this.$store.state.etest.grdList
    },
    grdDetail() {
      return this.$store.state.etest.grdDetail
    },
    univImg() {
      return this.$store.state.etest.univImg
    }
  },
  watch: {
    majorList: {
      deep: true,
      handler() {
        this.department = JSON.parse(JSON.stringify(this.majorList[this.activeIndex]))
      }
    },
    popupState() {
      console.log(this.popupState)
    },
    checkRate(){
      if(!this.checkRate) {
        for(var i in this.score) {
          this.score[i].rank = 0
        }
      }
    },
    department() {
      this.$store.dispatch('etest/getMajorGrdList' , this.department.id).then(()=> {
        console.log(this.grdList)
        this.grd = JSON.parse(JSON.stringify(this.grdList))
        console.log(this.grd)
      })
    },
    score: {
      deep: true,
      handler() {
        if(this.checkScore){
          this.sumAllScore()
          return
        }
        if(this.checkRate) {
          this.sumAllRate()
          return
        }
      },
    },
    grdList: {
      deep: true,
      handler() {
        this.grd = JSON.parse(JSON.stringify(this.grdList))
        if(this.grdList.length) {
          console.log(this.grdList[0].id)
          this.$store.dispatch('etest/getGrdDetail' , this.grdList[0].id).then(()=> {
            this.grdInfo = JSON.parse(JSON.stringify(this.grdDetail))
          })
        } else {
          this.grdInfo = {}
        }
      },
    },
    serviceState() {
      if(this.serviceState) {
        console.log('서비스 on')
      } else {
        console.log('서비스 off')
      }
    },
    // selectedYear() {
    //   this.sortScoreList()
    //   this.setRecruitInfo()
    //   this.sumAllScore()
    // }
  },
  methods: {
    init() {
      this.collegeInfo = JSON.parse(JSON.stringify(this.activeCollege))
      this.major = JSON.parse(JSON.stringify(this.activeMajor))
      this.grd = JSON.parse(JSON.stringify(this.grdList))
      this.$store.dispatch('etest/getUnivImage' , this.collegeInfo.id)
      if(this.majorList.length != 0){
        this.department = JSON.parse(JSON.stringify(this.majorList[0]))
        var date = this.$moment(new Date).format('YYYY');
        for(var i= 2017; i< Number(date) + 1; i++) {
          this.yearList.unshift(i) 
        }
      }
      this.appearInfo(this.grd[0])
      // this.setRecruitInfo()
      // if(this.active.img_name) {
      //   this.images = require('@/assets/images/pages/college/' + this.active.img_name)
      // }
      // this.sortScoreList()
      // this.sumAllScore()
      // this.sumAllRate()
    },
    sortScoreList() {
      for(var i in this.defaultScore) {
        this.defaultScore[i].score = 0
      }
      var list = JSON.parse(JSON.stringify(this.scoreList))
      var filter = list.filter((item)=> {
        return item.majorList_id == this.department && item.subject_date_id == this.selectYear
      })
      console.log(filter)
        if(filter.length != 0) {
          this.score = filter.sort((a ,b)=> {
            return a.subject_type_id - b.subject_type_id
          })
        } else {
              this.score = []
        }
    },
    editTag() {
      this.department.job_list[this.activeTagIndex] = this.tagInput
      this.tagInput = ''
      this.activeTagEdit = false
    },
    setScore(val) {
      this.$set(this.grdInfo , 'subject_score_list' , val)
      this.scoreInfo = val
    },
    setRate(val) {
      console.log(val)
      this.$set(this.grdInfo , 'subject_score_list' , val)
      this.scoreInfo = val
    },
    commitTag() {
      if(this.department.job_list.length != 4) {
        var index = this.department.job_list.findIndex((item)=> {
          return item == this.tagInput
        })
        if(index == -1) {
          if(this.activeTagEdit) {
            this.editTag()
          } else {
            this.department.job_list.push(this.tagInput)
            this.count = 0
          }
        }
        if(index != -1){
          if(this.activeTagEdit) {
            this.editTag()
          } else {
            this.$vs.notify({
              title: '에러',
              text: '같은 태그는 입력할 수 없습니다.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
          return
        }
      } else {
        if(this.activeTagEdit) {
          this.editTag()
        } else {
          this.$vs.notify({
            title: '초과',
            text: '최대 4개까지 입력 가능합니다',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      }
      this.tagInput =''
      return
    },
    deleteTag() {
      if(this.tagInput == '') {
        this.count++
        if(this.count >= 2) {
          this.department.job_list.pop()
        }
      }
    },
    sumAllScore() {
      this.totalSum = 0
        for(var i in this.score) {
            this.totalSum += Number(this.score[i].score)
        }
    },
    sumAllRate() {
      this.totalRate = 0
      var rate = 0
      for(var i in this.score) {
        if(this.score[i].rank > 0) {
          rate += Number(this.score[i].rank)
          this.totalRate = Number(rate/6).toFixed(1)
        }
      }
    },
    setRecruitInfo() {
      var majorIndex = this.majorList.findIndex((item)=> {
        return item.id == this.department.id
      })
      if(this.majorList[majorIndex].job_list) {
        for(var i; i<this.majorList[majorIndex].job_list[i]; i++){
          this.tag[i] = this.majorList[majorIndex].job_list[i];
        }
      } else {
        this.tag = []
      }
      var index = this.major[majorIndex].major_info.findIndex((item)=> {
        return item.date_id == this.selectYear
      })
      if(index != -1) {
        this.recruitInfo = this.majorList[majorIndex].major_info[index]
      } else {
        this.recruitInfo = {}
      }
    },
    handleFileChange(e) {
      var maxSize = 5 * 1024 * 1000
      var fileSize = e.target.files[0].size
      if(maxSize < fileSize) {
          return
      } else {
          var img = e.target.files[0]
          console.log(img)
          this.$store.dispatch('etest/uploadUnivImage' , {
            id: this.collegeInfo.id,
            file: img
          }).then(()=> {
            this.$store.dispatch('etest/getUnivImage' , this.collegeInfo.id)
          })
      }
    },
    saveSchoolInfo() {
      this.$store.dispatch('etest/saveUnivInfo', {
        'id': this.collegeInfo.id, 
        'image_name': null, 
        "name": this.collegeInfo.name, 
        'slogan':this.collegeInfo.slogan, 
        'info': this.collegeInfo.info,
        "campus_name":this.collegeInfo.campus_name,
        "school_type": this.collegeInfo.school_type,
        "school_gubun":this.collegeInfo.school_gubun,
        "address":this.collegeInfo.address,
        "home_link": this.collegeInfo.home_link,
        "service" : this.collegeInfo.service
      }).then(()=>{
          console.log(this.activeMajor)
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: '변경사항이 저장되었습니다 :)'
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 해주세요 :('
          })
        })
    },
    appearRight(val , index) {
      this.$store.dispatch('etest/getMajorGrdList' , val.id)
      this.department = JSON.parse(JSON.stringify(val))
      this.activeIndex = index
    },
    appearInfo(val , index) {
      this.$store.dispatch('etest/getGrdDetail' , val.id).then(()=> {
        this.grdInfo = JSON.parse(JSON.stringify(this.grdDetail))
      })
      this.activeGrdIndex = index
    },
    saveMajorInfo() {
      this.$store.dispatch('etest/saveMajorItem', {
          'univ_id':this.collegeInfo.id, 
          'name': this.department.name, 
          'group_type': null, 
          'job_list': this.department.job_list, 
          'info': this.department.info, 
          'id': this.department.id
        }).then(()=> {
          this.$vs.notify({
            title: '완료',
            text: '학과 정보가 저장되었습니다.',
            color: 'success'
          })
      }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 해주세요 :('
          })
        })
    },
    delMajorItem(val, index) {
      this.$store.dispatch('etest/deleteMajorItem', val.id)
        .then(()=>{
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: '삭제 완료 되었습니다'
          })
          if(this.majorList.length != 0){
            if(index == 0) {
              this.department = this.majorList[index]
            } else {
              this.department = JSON.parse(JSON.stringify(this.majorList[index - 1])) 
            }
          }
          else{
            this.department = null
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 해주세요 :('
          })
        })
    },
    delMajorInfo(val) {
      this.$store.dispatch('etest/deleteMajorItem', val)
        .then(()=>{
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: '삭제 완료 되었습니다'
          })
          console.log('123')
          if(this.majorList.length != 0){
            var index  = this.activeIndex
            if(index == 0) {
              this.department = this.majorList[index]
            } else {
              this.department = JSON.parse(JSON.stringify(this.majorList[index - 1])) 
            }
          } else {
            this.department = null
          }
          // this.appearRight(this.department)
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 해주세요 :('
          })
        })
    },
    deleteYear(val) {
      this.$store.dispatch('etest/deleteMajorGrd' , val.id).then(()=>{
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: '삭제 완료 되었습니다'
          })
          this.$store.dispatch('etest/getMajorGrdList' , this.department.id).then(()=> {
            console.log(this.grdList)
            this.grd = JSON.parse(JSON.stringify(this.grdList))
            console.log(this.grd)
          })
          // this.appearRight(this.department)
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 해주세요 :('
          })
        })
    },
    addMajorGrdItem(){
      console.log(this.selectYear)
      console.log(this.groupType)
      console.log(this.valType)
      console.log(this.department)
      this.$store.dispatch('etest/addMajorGrd', {
        "major_id": this.department.id,
        "type_id": this.groupType,
        "val_type_id": this.valType,
        "year": this.selectYear,
    }).then(()=> {
        this.popupActive = false
        this.$vs.notify({
          title: '완료',
          text: '학과 정보가 저장되었습니다.',
          color: 'success'
        })
      })
    },
    saveGrdInfo() {
      console.log(this.grdInfo)
      this.$store.dispatch('etest/saveMajorGrd' , this.grdInfo).then(()=> {
        this.$vs.notify({
            title: '완료',
            text: '학과 정보가 저장되었습니다.',
            color: 'success'
          })
      }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 해주세요 :('
          })
        })
    }
  },
  created() {
    this.init()
  }
}
</script>

<style>
.major_bg {
  background-color: #EDF7FC;
  /* color: white !important; */
}
.grd_bg {
  background-color: #FAECC5;
}

.hover:hover {
  /* background-color: #1D9CC8; */
  /* color: white !important; */
  background-color: #EDF7FC;
}

.yearhover:hover {
  background-color: #FAECC5;
}
</style>
